module.exports = __webpack_public_path__ + "img/videoLogo.61e9446c.png";